import React, { useEffect, useState } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import CountDownBadge from '../../common/CountDown/CountDownBadge';
import { CardMedia } from '../../common/Card';
import { DiscoveryCardBottomInfoBlock } from '../DiscoveryCardBottomInfoBlock/DiscoveryCardBottomInfoBlock';
import style from './DiscoveryItemWidgetMedia.scss';
import { rocket } from './missionImage';
import { leaderboardImage } from './leaderboardImage';
import { passTheParcelDefaultImage } from './passTheParcelDefaultImage';

export const DiscoveryItemWidgetMedia = ({
                    fakeState = 'empty',
                    myeventRegistrationStartTime,
                    myeventRegistrationEndTime,
                    image,
                    status,
                    registrationStatus,
                    rank,
                    displayCountdown,
                    colorName = 'dark',
                    isParcel,
                    missions,
                    joined,
                    ...countDown
                }) => {

    const [isLoadBannerFailed, setIsLoadBannerFailed] = useState(false);
    const detectUpTextKey = () => {
        if (isParcel) { return 'promotionFinished'; }
        if (missions) { return 'campaignFinished'; }
        return status === 'PENDING_REVIEW' ? 'resultsPending' : 'resultsConfirmed';
    };

    useEffect(() => {
        const img = new Image();
        img.src = image;
        img.onerror = function() {
            setIsLoadBannerFailed(true);
        };
    }, [image]);

    const defineBannerImage = () => {
        if (missions) {
            return !image || isLoadBannerFailed ? rocket : image;
        }
        if (isParcel) {
            return !image || isLoadBannerFailed ? passTheParcelDefaultImage : image;
        }
        return !image || isLoadBannerFailed ? leaderboardImage : image;
    };

    const isFinished = fakeState === 'discoveryFinished';
    const t = usePortletTranslations();
    return (
        <>
            {displayCountdown && !isFinished
            && (
                <CountDownBadge
                    className={style.hello}
                    status={status}
                    color={colorName}
                    {...countDown}
                    importedStyle={style}
                />
            )}
            {fakeState === 'discoveryFinished' &&
            <div className={style.topBanner}>{t(detectUpTextKey())}</div>}
            <CardMedia className={style.media} image={defineBannerImage()}/>
            <DiscoveryCardBottomInfoBlock missions={missions} fakeState={fakeState} joined={joined}/>
        </>
    );
};

